var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-complete-profile",attrs:{"flat":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("checkout.confirmEmailTitle"))+" ")]),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.$t("checkout.confirmEmailSubTitle"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }